<template>
  <v-card class="pa-0" elevation="0">
    <v-card-text class="px-6 py-6">
      <div class="py-16 text-center">
        <br><br><br>
        <v-progress-circular color="primary" indeterminate size="25"></v-progress-circular>
        <div class="mx-auto mt-10 text-h6" style="max-width: 300px">
          {{ loading || 'Please wait..' }}
        </div>
        <br><br><br>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { jsonToBase64 } from "@/lib/utils";

export default {
  name: "EligibilityWidget",
  data() {
    return {
      loading: '',
      request: this.$store.state.request,
      merchant: this.$store.state.merchant,
      cc: null,
      view: ''
    }
  },
  created() {
    this.launchDataCollectionWidget();
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
    if (this.iframe) this.iframe.remove();
  },
  methods: {
    async handleMessage(e) {
      if (!e.data || !e.data.id) return;
      if (e.data.id === 'cclan-frame-loaded') {
        this.loading = '';
      }
      if (e.data.id === 'cclan-cancel' || e.data.id === 'cclan-completed') {
        this.loading = '';
        this.$emit('cancel');
        this.iframe.remove();
        await this.$store.dispatch('request/load', this.$store.state.request.global_request_id);
      }
    },
    async getGlobalSetting() {
      try {
        const res = await this.$http.post('https://mobile.creditclan.com/api/v3/bnpl/global/settings', {}, {
          headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
        });
        return res.data.response ?? {};
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getLenderSetting({ ecosystem, amount, lender_id }) {
      try {
        const res = await this.$http.post('https://mobile.creditclan.com/api/v3/bnpl/data_needs', {
          ecosystem, amount, lender_id: lender_id || '40425'
        }, {
          headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
        });
        return res.data.response ?? {};
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async launchDataCollectionWidget() {
      const { customer, request } = this.$store.state;
      const global_settings = await this.getGlobalSetting();
      const lender_settings = await this.getLenderSetting({
        ecosystem: 'shop', amount: request.total_credit, lender_id: null
      });
      const { lender_id, lender_name, image } = global_settings?.funding_partner ?? {};
      const lender = { id: lender_id, name: lender_name, image };
      const data = {
        banner: 'https://merchants.creditclan.com/assets/images/man-smiling.jpeg',
        request: {
          amount: this.$store.getters['request/totalAmount'],
          tenor: request.no_of_months,
        },
        profile: {
          full_name: customer.personal.full_name,
          email: customer.personal.email,
          phone: customer.personal.phone,
          date_of_birth: customer.personal.date_of_birth,
          profile_image: '',
        },
        home_address: {
          address: customer.personal.address,
          state_id: customer.personal.state,
          lga_id: customer.personal.lga
        },
        stage: request.stage,
        request_id: request.creditclan_request_id,
        lender: request.lender || lender,
        config: {
          no_frequently_called_numbers: 1,
          analyze_bank_statement: true,
          tokenize_card: true,
          show_offers: true,
          show_bank_account: true,
          show_work_information: true,
          platform: 'shop-global',
          show_nin: lender_settings?.run_identity ?? true,
          show_signature: true,
          show_address: true,
        },
        extra: {
          global_request_id: this.$store.state.request.global_request_id
        },
        email_verified: request.email_verified
      };
      const token = jsonToBase64(data);
      const url = `https://creditclanbnpl-widget.creditclan.com/?token=${ token }`;
      this.loading = `Connecting with banks..`;
      this.launchIframe(url);
    },
    launchIframe(url) {
      const iframe = document.createElement('IFRAME');
      iframe.setAttribute('src', url);
      iframe.setAttribute('allow', 'geolocation');
      const style = {
        'z-index': '999999',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100vh',
      };
      Object.assign(iframe.style, style);
      this.iframe = iframe;
      document.body.append(iframe);
    },
    async addToCompleted(value) {
      const id = this.request.id;
      const analysis_completed = [...this.request.analysis_completed];
      analysis_completed.push(value);
      await this.$http.patch(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/stages/${ id }`, {
        analysis_completed, type: 'customer'
      });
      this.$store.commit('request/set', { analysis_completed });
    }
  }
}
</script>
